<template>
  <div class="menu-footer">
    Ein Spiel von <a href="https://kovah.de/">Kovah.de</a> | <a href="https://github.com/Kovah/Taboo">Github</a>
  </div>
</template>

<script>
  export default {
    name: 'MenuFooter'
  };
</script>
